/**
 * @file コンポーネント：リスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledList = styled.ul``;

export const StyledListItem = styled.li`
    line-height: 1.3;

    &[data-list-style-type="disc"] {
        list-style-type: disc;
        margin-left: 2em;
    }

    &[data-list-style-type="icon"] {
        list-style-type: none;
        position: relative;
        padding-left: 2em;

        &::before {
            position: absolute;
            top: 0;
            left: 0;
            width: 4em;
            font-size: 0.5em;
            line-height: 2.6em;
            text-align: center;
            content: attr(data-icon);
        }

        &[data-icon-weight="bold"] {
            &::before {
                font-weight: bold;
            }
        }
    }

    &[data-on-color="gray"] {
        color: #757575;
    }

    &[data-on-color="main"] {
        color: #ffffff;
    }

    &[data-on-color="white"] {
        color: #757575;
    }
`;
